import styled from 'styled-components';
import { GRID_AREAS } from 'settings';

const Title = styled.h4.attrs({ className: 'FieldsWarning' })`
  margin-top: 1rem;

  ${({ area }) =>
    typeof area === 'boolean'
    && `
    grid-area: ${area ? GRID_AREAS.LEFT.WARNING : GRID_AREAS.RIGHT.WARNING};
  `}
`;

export { Title };
